import React from "react";
import HeroSectionCard from "../HeroSectionCard";

const OfferHeader = ({ offer, currency }) => (
  <HeroSectionCard
    slideImages={[offer?.image]}
    menuID={offer?.id}
    title={offer?.title}
    subTitle={`${currency || "$"} ${Number(offer?.price).toFixed(2)}`}
    content={offer?.description}
  />
);

export default OfferHeader;
